import { defineStore, mapActions } from "pinia";
import { useAxiosStore } from "js/stores/axiosStore.js";

export const useSavedIdeaStore = defineStore("savedIdeaStore", {
    state: () => {
        return {
            dirty: true,
            list: [],
            index: {},
        };
    },
    actions: {
        populate(items) {
            this.list = items;
            this.dirty = false;
            this.buildIndex();
        },

        find(title) {
            const i = this.index[title.toLowerCase()];
            if (i === undefined) {
                return null;
            }
            return this.list[i];
        },

        async load() {
            if (this.dirty || this.list.length === 0) {
                this.populate(
                    (await this.fetch("/api/saved-trip-ideas")) || []
                );
            }
        },

        async save(rec) {
            const data = await this.create("/api/saved-trip-ideas", {
                title: rec.title,
                countries: rec.countries,
                summary: rec.summary,
                why_it_fits: rec.why_it_fits,
                ideal_duration: rec.ideal_duration,
                ideal_season: rec.ideal_season,
                ideal_months: rec.ideal_months,
                highlights: rec.highlights,
                locations: rec.locations,
                image_query: rec.image_query,
                pexel_images: rec.pexel_images ?? null,
                short_title: rec.short_title ?? null,
                budget_level: rec.budget_level ?? null,
                pace: rec.pace ?? null,
                themes: rec.themes ?? null,
                connection_mode: rec.connection_mode ?? null,
                connection_hours: rec.connection_hours ?? null,
            });
            if (data) {
                this.list.unshift(data);
                this.buildIndex();
            }
            return data;
        },

        async remove(id) {
            await this.delete(`/api/saved-trip-ideas/${id}`);
            this.list = this.list.filter((idea) => idea.id !== id);
            this.buildIndex();
        },

        buildIndex() {
            this.index = {};
            this.list.forEach((idea, i) => {
                this.index[idea.title.toLowerCase()] = i;
            });
        },

        setDirty() {
            this.dirty = true;
        },

        ...mapActions(useAxiosStore, ["fetch", "create", "delete"]),
    },
});
